<template>
    <div class="bodyheight grid gridadmin bg-gray-100 dark:bg-black relative">
        <bg-global :bgLobby="bgLobby" />

        <admin-panel-menu @admin-button-click="adminButtonClick" :active="active"></admin-panel-menu>

        <ul class="bodyheight-adminarea overflow-auto adminarea z-10">

            <admin-sub-panel-stats v-if="active === 'stats'" :token="token" />

            <admin-sub-panel-users v-if="active === 'users'" :token="token" />

            <admin-sub-panel-balances v-if="active === 'balances'" :tokens="tokens" :token="token" />

            <admin-sub-panel-sponsors v-if="active === 'sponsors'" :token="token" :page="page"
                @sponsor-add-edit="sponsorAddEdit" />

            <admin-sub-panel-sponsor v-if="active === 'sponsor'" :token="token" :sponsor_id="sponsor_id" :page="page"
                @back-to-sponsors="backToSponsors" />

            <admin-sub-panel-bots v-if="active === 'bots'" :token="token" :page="page" :games="games" />

            <admin-sub-panel-tickets v-if="active === 'tickets'" :token="token" :page="page" />

        </ul>

    </div>
</template>

<script>
import AdminPanelMenu from './AdminPanelMenu.vue'
import AdminSubPanelBalances from './AdminSubPanelBalances.vue'
import AdminSubPanelSponsors from './AdminSubPanelSponsors.vue'
import AdminSubPanelSponsor from './AdminSubPanelSponsor.vue'
import AdminSubPanelBots from './AdminSubPanelBots.vue'
import AdminSubPanelStats from './AdminSubPanelStats.vue'
import AdminSubPanelUsers from './AdminSubPanelUsers.vue'
import AdminSubPanelTickets from './AdminSubPanelTickets.vue'

export default {
    name: 'AdminPanel',
    components: {
        AdminPanelMenu,
        AdminSubPanelBalances,
        AdminSubPanelSponsors,
        AdminSubPanelSponsor,
        AdminSubPanelBots,
        AdminSubPanelStats,
        AdminSubPanelUsers,
        AdminSubPanelTickets
    },
    props: ['token', 'bgLobby', 'tokens', 'games'],
    data() {
        return {
            active: 'stats',
            sponsor_id: null,
            page: 1,
        }
    },
    methods: {
        adminButtonClick(target) {
            this.active = target
        },
        sponsorAddEdit(value) {
            this.active = 'sponsor'
            this.sponsor_id = null
            this.page = 1
            if (value !== null) {
                this.sponsor_id = value.sponsor_id
                this.page = value.page
            }
        },
        backToSponsors(page) {
            this.page = page
            this.active = 'sponsors'
        }
    }
}
</script>
